module.exports = __webpack_public_path__ + "media/images/strategic-partners/new/Medcurity-a65fc513b96d8beeccdf59fbdfe84fb4.png";